import View from './View.js';
// import { Fraction } from 'fractional';

import icons from 'url:../../img/icons.svg';

class RecipeView extends View {
  _parentEl = document.querySelector('.recipe');
  _errorMessage = 'Não encontramos nenhuma receita. Por favor, tente outra!';
  _message;
  addHandlerRender(handler) {
    const events = ['hashchange', 'load'];
    events.forEach(e => window.addEventListener(e, handler));
  }

  addHandlerUpdateServings(handler) {
    this._parentEl.addEventListener('click', e => {
      const btn = e.target.closest('.btn--tiny');
      if (!btn) return;

      const { updateTo } = btn.dataset;
      handler(+updateTo, btn);
    });
  }

  addHandlerAddBookmark(handler) {
    this._parentEl.addEventListener('click', e => {
      const btn = e.target.closest('.btn--bookmark');
      if (!btn) return;

      handler();
    });
  }

  _ingredientsToHtml() {
    return this._data.ingredients
      .map(ing => {
        return `<li class="recipe__ingredient">
        <svg class="recipe__icon">
          <use href="${icons}#icon-check"></use>
        </svg>
        <div class="recipe__quantity">${
          !ing.quantity ? (ing.quantity = '') : ing.quantity
        }</div>
        <div class="recipe__description">
          <span class="recipe__unit">${ing.unit}</span>
          ${ing.description}
        </div>
      </li>`;
      })
      .join('');
  }

  _generateHtml() {
    return `
    <figure class="recipe__fig">
    <img src="${this._data.image}" alt="${
      this._data.title
    }" class="recipe__img" />
    <h1 class="recipe__title">
      <span>${this._data.title}</span>
    </h1>
    </figure>
    
    <div class="recipe__details">
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-clock"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--minutes">${
        this._data.cookingTime
      }</span>
      <span class="recipe__info-text">minutos</span>
    </div>
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-users"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--people">${
        this._data.servings
      }</span>
      <span class="recipe__info-text">Porções</span>
    
      <div class="recipe__info-buttons">
        <button class="btn--tiny btn--increase-servings" data-update-to="${
          this._data.servings - 1
        }">
          <svg>
            <use href="${icons}#icon-minus-circle"></use>
          </svg>
        </button>
        <button class="btn--tiny btn--increase-servings" data-update-to="${
          this._data.servings + 1
        }">
          <svg>
            <use href="${icons}#icon-plus-circle"></use>
          </svg>
        </button>
      </div>
    </div>
    
    <div class="recipe__user-generated ${this._data.key ? '' : 'hidden'}">
     <svg>
     <use href="${icons}#icon-user"></use>
     </svg>
    </div>
    <button class="btn--round btn--bookmark">
      <svg class="">
        <use href="${icons}#icon-bookmark${
      this._data.bookmarked ? '-fill' : ''
    }"></use>
      </svg>
    </button>
    </div>
    
    <div class="recipe__ingredients">
    <h2 class="heading--2">Ingredientes</h2>
    <ul class="recipe__ingredient-list">
    ${this._ingredientsToHtml()}
  
    </ul>
    </div>
    
    <div class="recipe__directions">
    <h2 class="heading--2">Modo de Preparo</h2>
    <p class="recipe__directions-text">
      Esta receita foi cuidadosamente projetada e testada por
      <span class="recipe__publisher">${
        this._data.publisher
      }</span>. Por favor, confira as instruções no site deles.
    </p>
    <a
      class="btn--small recipe__btn"
      href="${this._data.sourceUrl}"
      target="_blank"
    >
      <span>Instruções</span>
      <svg class="search__icon">
        <use href="${icons}#icon-arrow-right"></use>
      </svg>
    </a>
    </div>`;
  }
}

export default new RecipeView();
